import DeviceMixin from 'components/mixins/device-mixin'
import { getV2BaseUrl } from '@/utils/v2-base-url'

export default {
  mixins: [DeviceMixin],
  methods: {
    watchQuery(models) {
      models.forEach(m => this.$watch(m, v => this.pushQuery(m, v)))
    },
    pushQuery(k, v) {
      this.$router.push({
        query: { ...this.$route.query, [k]: v },
      })
    },
    directionsTo(address) {
      const url = `https://www.google.com/maps/dir/?api=1&destination=${address}`
      window.open(url, '_blank')
    },
    updateFromQuery(models) {
      models.forEach(m => {
        const queryVal = this.$route.query[m]
        if (queryVal) this[m] = queryVal
      })
    },
    getReservationUrl(res_id) {
      const user = this.$store.state.user
      const moduleVersions = user?.module_versions || {}
      if (moduleVersions.reservation_page?.module_version === 2) {
        return `${getV2BaseUrl()}/app/reservation/${res_id}`
      }
      return `/dashboard/reservation/${res_id}`
    },
    goToReservation(res_id) {
      this.navigateTo(this.getReservationUrl(res_id))
    },
    navigateTo(path) {
      this.isMobileOrIPad
        ? this.$router.push(path)
        : window.open(path, '_blank')
    },
  },
}
